<template>
  <div
    class="d-flex flex-column gr-8"
  >
    <div>
      <div
        class="mb-4"
        :class="isMobile ? 'text-subtitle-1' : 'text-h6'"
      >
        {{ t('Как зарегистрироваться самостоятельно', options) }}
      </div>
      <ol class="d-flex flex-column gr-2 text-body-1 pl-5 mb-2">
        <li>{{ t('Убедитесь, что выбран верный город для поиска', options) }}</li>
        <li>
          {{
            t(
              'Найдите свой профиль по ФИО на {site}',
              {
                ...options,
                site: context.request.country.is_russia
                  ? 'ПроДокторов'
                  : 'YDoc',
              },
            )
          }}
        </li>
        <li>{{ t('Нажмите кнопку «Это вы?»', options) }}</li>
        <li>{{ t('Продолжите регистрацию', options) }}</li>
      </ol>
      <a
        class="text-body-1 primary--text link-decoration-none"
        :href="context.request.country.is_russia
          ? 'https://help.prodoctorov.ru/kak-doktoru-zaregistrirovatsya-na-portale-prodoktorov/'
          : 'https://help.ydoc.me/kak-doktoru-zaregistrirovatsya-na-portale-ydoc/'"
        target="_blank"
        rel="noopener noreferrer"
      >{{ t('Подробнее в статье', options) }}</a>
    </div>

    <v-btn
      v-if="isMobile"
      color="primary"
      depressed
      @click="openSearch"
    >
      {{ t('Найти профиль', options) }}
    </v-btn>

    <div
      v-if="companyContacts.length"
      class="d-flex"
    >
      <div class="flex-grow-1">
        <div
          class="mb-4"
          :class="isMobile ? 'text-subtitle-1' : 'text-h6'"
        >
          {{ t('С помощью наших специалистов', options) }}
        </div>

        <div class="text-body-1">
          {{ t('Напишите свои ФИО и город нам в чат:', options) }}
        </div>

        <ol class="text-body-1 pl-5 mb-3">
          <li
            v-for="(companyContact, index) in companyContacts"
            :key="index"
          >
            {{ companyContact.text }}
            <a
              :href="companyContact.href"
              target="_blank"
              rel="noopener noreferrer"
              class="primary--text link-decoration-none"
            >{{ companyContact.hrefText }}</a>{{ companyContact.hasQr ? t(' или отсканируйте QR-код.', options) : '.' }}
          </li>
        </ol>

        <div class="text-body-1">
          {{ t('Ответим в течение 1 рабочего дня.', options) }}
        </div>
      </div>

      <v-img
        v-if="!isMobile"
        class="flex-grow-0"
        :src="qrSrc"
        width="150"
        height="150"
        :alt="t('QR-код', options)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import I18NextVue from 'i18next'
import type { ContextStore } from 'src/components/pages/profile/doctors/register/index/types'
import useContextStore from 'src/store/useContextStore'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()
const isMobile = computed(() => context.flavour === 'mobile')

const companyContacts = computed(() => {
  const contacts: Array<{
    text: string
    href: string
    hrefText: string
    hasQr: boolean
  }> = []

  if (context.company_contact?.messengers_dict.telegram) {
    contacts.push({
      text: 'Telegram',
      href: `https://t.me/${context.company_contact.messengers_dict.telegram}`,
      hrefText: `@${context.company_contact.messengers_dict.telegram}`,
      hasQr: context.request.country.iso.toLowerCase() !== 'kz' && !isMobile.value,
    })
  }

  if (context.company_contact?.messengers_dict.max) {
    contacts.push({
      text: t('Написать в', options),
      href: `https://max.ru/${context.company_contact.messengers_dict.max}`,
      hrefText: 'Max',
      hasQr: false,
    })
  }

  if (context.company_contact?.messengers_dict.whatsapp) {
    contacts.push({
      text: 'WhatsApp',
      href: `https://wa.me/${context.company_contact.messengers_dict.whatsapp}`,
      hrefText: context.company_contact.messengers_dict.whatsapp,
      hasQr: context.request.country.iso.toLowerCase() === 'kz',
    })
  }

  return contacts
})

const qrSrc = computed(() => {
  switch (context.request.country.iso.toLowerCase()) {
    case 'kz':
      return '/static/_v1/pd/qr/registration/doctor-whatsapp.png'
    case 'kg':
      return '/static/_v1/pd/qr/registration/doctor-whatsapp-kg.png'
    default:
      return '/static/_v1/pd/qr/registration/doctor-telegram.png'
  }
})

const searchTriggerButton = ref<HTMLInputElement | null>(null)

function openSearch() {
  if (!searchTriggerButton.value) {
    searchTriggerButton.value = document.querySelector('[data-js-btn-search]')
  }

  searchTriggerButton.value?.click()
}
</script>
